import { render, staticRenderFns } from "./veStuGraduationClas.vue?vue&type=template&id=09a43954&scoped=true"
import script from "./veStuGraduationClas.vue?vue&type=script&lang=js"
export * from "./veStuGraduationClas.vue?vue&type=script&lang=js"
import style0 from "./veStuGraduationClas.vue?vue&type=style&index=0&id=09a43954&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a43954",
  null
  
)

export default component.exports